'use client'

import * as React from 'react'

import cn from '@config/tailwind/cn'

interface YoutubeIframeBlockFields {
  blockType: 'youtube-iframe'
  videoId: string
  title?: string
  description?: string
}

interface YoutubeIframeBlockProps {
  fields: YoutubeIframeBlockFields
}

export function YoutubeIframeBlock({ fields }: YoutubeIframeBlockProps) {
  return (
    <div className='ui:my-6'>
      {fields.title && <h5 className='ui:mb-3 ui:text-lg ui:font-semibold ui:text-neutral-black'>{fields.title}</h5>}
      <div className='ui:relative ui:aspect-video ui:w-full ui:overflow-hidden ui:rounded-xl ui:shadow-lg'>
        <iframe
          src={`https://www.youtube.com/embed/${fields.videoId}`}
          title={fields.title ?? 'YouTube video'}
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          allowFullScreen
          loading='lazy'
          className='ui:absolute ui:inset-0 ui:h-full ui:w-full'
        />
      </div>
      {fields.description && (
        <p className={cn('ui:mt-2 ui:text-sm ui:text-center ui:text-grey-100')}>{fields.description}</p>
      )}
    </div>
  )
}
